<template>
  <div>
    <el-form class="page-panel-search-form" :inline="true">
      <el-form-item>
        <el-input placeholder="请输入关键字" v-model="serchModel.newsTitle"> </el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="default" icon="el-icon-search" @click="getNewsList"></el-button>
      </el-form-item>
      <el-form-item class="page-panel-search-form-right-button">
        <el-button type="primary" @click="add">新增</el-button>
      </el-form-item>
    </el-form>
    <ul class="article-list">
      <li class="article-list_item" v-for="(item,index) in newsList" :key="index">
        <div class="article-list-item__body">
          <div class="article-list-item__index"><i class="index">{{index+1+((serchModel.pageNo-1))*10}}</i></div>
          <div class="article-title">
            <a class="article-title__name" href="javascript:;" @click="edit(item.newsId)">{{item.newsTitle}}</a>
            <div class="article-title__icons">
              <el-tag size="mini" class="article-title-icon">{{item.newsStatus==0?'已发布':'草稿'}}</el-tag>
            </div>
          </div>
          <div class="article-attrs">
            <span class="article-attr__item">发布日期： {{item.promTime}}</span>
          </div>
          <div class="article-content">{{item.newSmBody}}</div>
          <ul class="article-thumbs" v-viewer v-if="item.picMain">
            <img class="article-thumb" :src="item.picMain" width="150px" height="100px"
              onerror="this.src='/static/img/unload.gif'">
          </ul>
          <div class="article-attrs">
            <span class="article-attr__item_grey">新闻由</span>
            <span class="article-attr__item_black">{{item.addUser}}</span>
            <span class="article-attr__item_grey">于</span>
            <span class="article-attr__item_black">{{item.addTime}}</span>
            <span class="article-attr__item_grey">上传</span>

          </div>
          <div class="article-control">
            <!-- <a class="article-control__item" href="javascript:;">查看</a> -->
            <a class="article-control__item" href="javascript:;" @click="edit(item.newsId)">编辑</a>
            <a class="article-control__item" href="javascript:;" @click="delnew(item.newsId)">删除</a>
          </div>
        </div>
      </li>
    </ul>
    <div class="page-panel__footer">
      <el-pagination :current-page.sync='serchModel.pageNo' :page-size='serchModel.pageSize'
        layout='prev, pager, next, jumper' :total='total' @current-change='getNewsList'>
      </el-pagination>
    </div>
  </div>
</template>

<script>
import * as newsApi from '@/api/adminApi/zh/news';
export default {
  data() {
    return {
      total: 0,
      newsList: [],
      serchModel: {
        pageNo: 1,
        pageSize: 10
      },
      list: []
    };
  },
  methods: {
    add() {
      this.$router.push({
        path: '/admin/article/enterprise/add'
      });
    },
    getNewsList() {
      newsApi.getNewsList(this.serchModel).then(res => {
        this.newsList = res.data.list;
        this.total = res.data.pageTotal;
      });
    },
    delnew(newsId) {
      this.$confirm('是否确认删除该文章', {
        distinguishCancelAndClose: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
        .then(() => {
          newsApi.delnew({ newsId: newsId }).then(res => {
            this.getNewsList();
          });
        })
        .catch(action => {
          this.$message({
            type: 'info',
            message: '已取消'
          });
        });
    },
    edit(newsId) {
      this.$router.push({
        path: `/admin/article/enterprise/edit/${newsId}`
      });
    }
  },
  created() {
    this.getNewsList();
  }
};
</script>

<style lang="stylus" scoped>
@import '../../../../../assets/stylus/color'

.article-list .article-list_item .article-list-item__body:hover {
  .index {
    color #fff
    background-color $color-main
    left 14px
  }
  .article-title__name {
    color $color-main
  }
}
.article-list-item__index {
  float left
  margin-top 4px
  margin-right 5px
  i {
    padding-left 2px
    padding-right 2px
  }
}
.article-list-item__info {
  float left
  width 95%
}
</style>



// WEBPACK FOOTER //
// src/pages/adminCenter/page/article/enterprise/list.vue